import React, { useState } from "react";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { CrmReportForm, CrmReportResults } from "../../components/report";

export const CrmReport = () => {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);

  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title="CRM Report" />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        {/* form section */}
        <CrmReportForm loading={loading} setLoading={setLoading} onGenerate={(data) => setReportData(data)} />
      </Box>

      {/* results section */}
      {reportData.length > 0 && <CrmReportResults loading={loading} data={reportData} />}
    </PageLayout>
  );
};
